<template>
    <el-row :gutter="20" type="flex" class="flex-justify-left">
      <el-radio-group
        class="margin-left-20"
        v-model="formQuery.os"
        size="mini"
        @change="osInfosChange"
      >
        <el-radio-button
          v-for="item in osInfos"
          :key="item.os"
          :label="item.value === undefined ? item.os : item.value"
        >{{ item.os }}</el-radio-button>
      </el-radio-group>
      <!-- <el-select
        class="margin-left-10"
        size="mini"
        @change="osVersionChange"
        v-model="formQuery.osVersion"
        placeholder="请选择版本"
        clearable
        v-if="!noShowVersionList"
      >
        <el-option v-for="(item, index) in osVersions" :key="`osVersion-${index}`"
          :label="item.os === undefined ? item : item.os"
          :value="item.value === undefined ? item : item.value">
        </el-option>
      </el-select> -->
    </el-row>
</template>
<script>
// import { mapGetters } from 'vuex';
// import Moment from 'moment';
// import { queryOsInfo } from '@/api/event';

export default {
  props: {
    os: {
      type: String,
      default: '',
    },
    osVersion: {
      type: String,
      default: '',
    },
    // noShowVersionList: {
    //   type: Boolean,
    //   default: false,
    // },
    // isMergeVersion: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  watch: {
    // },
    // source: {
    //   handler() {
    //     this.queryOsInfo();
    //   },
    // },
    // env: {
    //   handler() {
    //     this.queryOsInfo();
    //   },
    // },
    os(val) {
      this.formQuery.os = val;
    },
    osVersion(val) {
      this.formQuery.osVersion = val;
    },
  },
  data() {
    return {
      formQuery: {
        os: '',
        osVersion: '',
      },
      osInfos: [
        { os: 'ALL', value: '' },
        { os: 'mac', value: 'mac' },
        { os: 'windows', value: 'windows' },
        { os: 'iOS', value: 'iOS' },
        { os: 'Android', value: 'Android' },
      ],
      osVersions: [],
      range: [],
    };
  },
  computed: {
    // ...mapGetters('app', ['env', 'source']),
  },
  mounted() {
    // this.queryOsInfo();
  },
  methods: {
    // async queryOsInfo() {
    //   this.queryLoading = true;
    //   try {
    //     const { range } = this;
    //     const data = {
    //       analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
    //       analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
    //     };
    //     const {
    //       data: { osInfos },
    //     } = await queryOsInfo(data);

    //     this.osInfos.splice(0);
    //     if (this.isMergeVersion) {
    //       const info = [];
    //       // 匹配标准格式，合并 mac/windows/iOS/Android
    //       osInfos.forEach((item) => {
    //         if (['mac', 'windows', 'iOS', 'Android'].includes(item.os)) {
    //           info.push(item);
    //         }
    //       });
    //       this.osInfos.push(
    //         ...[{ os: 'ALL', value: '' }, ...info],
    //       );
    //     } else {
    //       this.osInfos.push(
    //         ...[{ os: 'ALL', value: '' }, ...osInfos],
    //       );
    //     }

    //     this.formQuery.os = '';
    //     this.osInfosChange();
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.queryLoading = false;
    //   }
    // },
    osVersionChange() {
      this.$emit('update:osVersion', this.formQuery.osVersion);
      this.$emit('update');
    },
    osInfosChange() {
      // const filterData = this.osInfos.filter(
      //   // eslint-disable-next-line comma-dangle
      //   (item) => item.os === this.formQuery.os
      // );

      // const [{ osVersions = [] }] = filterData.length
      //   ? filterData
      //   : [{ osVersions: [] }];

      this.$emit('update:os', this.formQuery.os);
      this.$emit('update');
      // this.formQuery.osVersion = '';
      // this.osVersions.splice(
      //   0,
      //   this.osVersions.length,
      //   // eslint-disable-next-line comma-dangle
      //   ...[{ os: '全部', value: '' }, ...osVersions]
      // );
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
